export const termsAndConditionsContentEn = {
    title: "Terms & Conditions",
    subtitle: "Terms & Conditions for Bitsclan IT Solutions",
    metaTitle: "Terms & Conditions | Legal Information | Bitsclan IT Solutions",
    intro:
        "Welcome to Bitsclan IT Solutions. By accessing or using our website & services, you agree to comply with the following Terms & Conditions. Please read these terms carefully. If you do not agree with any part of these terms, you should not use our services.",
    sections: [
        {
            heading: "1. Acceptance of Terms",
            content:
                "By using our website & services, you agree to be bound by these Terms & Conditions, as well as our Privacy Policy. If you are using our services on behalf of an organization, you represent that you have the authority to accept these terms on behalf of that organization.",
        },
        {
            heading: "2. Services Provided",
            content:
                "Bitsclan IT Solutions offers a range of services including IT consultancy, software development, & digital marketing solutions. We reserve the right to modify, suspend, or discontinue any of our services at our discretion without prior notice.",
        },
        {
            heading: "3. User Responsibilities",
            points: [
                {
                    label: "Account Creation",
                    description:
                        "If you are required to create an account to access certain features, you agree to provide accurate & complete information.",
                },
                {
                    label: "Prohibited Uses",
                    description:
                        "You are prohibited from using our services for illegal activities, including but not limited to fraud, infringement of intellectual property, or unauthorized access to systems.",
                },
            ],
        },
        {
            heading: "4. Intellectual Property",
            content:
                "All content on our website, including text, images, logos, software, & other materials, is the property of Bitsclan IT Solutions or its licensors. You may not copy, modify, distribute, or exploit this content without our express written consent.",
        },
        {
            heading: "5. Payment Terms",
            content:
                "For any paid services, you agree to provide accurate billing information. Payments must be made as outlined in your agreement or invoice. We reserve the right to suspend or terminate your access to services if payments are not made promptly.",
        },
        {
            heading: "6. Limitation of Liability",
            content:
                "To the fullest extent permitted by law, Bitsclan IT Solutions will not be liable for any indirect, incidental, or consequential damages arising from your use of our services. Our liability is limited to the amount you have paid for the services in question.",
        },
        {
            heading: "7. Privacy & Data Collection",
            content:
                "Your use of our services is also governed by our Privacy Policy, which outlines how we collect, use, & protect your personal data. By using our services, you consent to the collection & use of your data as described in the Privacy Policy.",
        },
        {
            heading: "8. Termination",
            content:
                "We may terminate or suspend your access to our services at any time without notice if you breach these Terms & Conditions or for any other reason deemed appropriate by us. Upon termination, you must immediately stop using our services.",
        },
        {
            heading: "9. Governing Law",
            content:
                "These Terms & Conditions shall be governed by & construed in accordance with the laws of [jurisdiction]. Any disputes shall be resolved exclusively in the courts of [jurisdiction].",
        },
        {
            heading: "10. Changes to Terms",
            content:
                "We reserve the right to modify these Terms & Conditions at any time. Any changes will be posted on this page with the updated effective date. Continued use of our services after such changes constitutes your acceptance of the updated terms.",
        },
        {
            heading: "11. Contact Us",
            content: "If you have any questions regarding these Terms & Conditions, please contact us at:",
            contact: {
                emailHeading: "Email",
                email: "hello@bitsclan.com",
                phoneHeading: "Phone",
                phone: "+1 315 666 8052",
                addresHeading: "Address",
                address: "New York 2 Park Ave 20th floor, New York, NY 10016",
            },
        },
    ],
};